var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailFill0Wght400Grad0Opsz481(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 22.5C3.4875 22.5 3.09375 22.3312 2.75625 21.9937C2.41875 21.6562 2.25 21.2625 2.25 20.8125V6.1875C2.25 5.7375 2.41875 5.34375 2.75625 5.00625C3.09375 4.66875 3.4875 4.5 3.9375 4.5H23.0625C23.5125 4.5 23.9062 4.66875 24.2437 5.00625C24.5812 5.34375 24.75 5.7375 24.75 6.1875V20.8125C24.75 21.2625 24.5812 21.6562 24.2437 21.9937C23.9062 22.3312 23.5125 22.5 23.0625 22.5H3.9375ZM13.5 14.0062L3.9375 7.73438V20.8125H23.0625V7.73438L13.5 14.0062ZM13.5 12.3187L22.95 6.1875H4.07812L13.5 12.3187ZM3.9375 7.73438V6.1875V20.8125V7.73438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill0Wght400Grad0Opsz481);
export default __webpack_public_path__ + "static/media/mail_FILL0_wght400_GRAD0_opsz481.33143cf2f6260279f5a02bf17cff497b.svg";
export { ForwardRef as ReactComponent };